import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
  import { useStore } from "vuex";
  import CustomerDetailsCardEmpty from "@/components/customer/CustomerDetailsCardEmpty.vue";
  import CustomerUploaderModal from "@/components/ui/modals/CustomerUploaderModal.vue";
  import ActionsComponent from "@/components/ui/ActionsComponent.vue";
  import RemoveDocumentsModal from "@/components/ui/modals/RemoveDocumentModal.vue";
  import { formatDateMonthDayYear } from "@/helpers/date";
  import router from "@/router";
  import { getUser } from "@/features/useUser";
  import DocumentItemWithSlot from "@/components/ui/DocumentItemWithSlot.vue";
  import DocumentItem from "@/components/ui/DocumentItem.vue";
  import { CustomerDetails } from "@/types/CustomerDetails";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDocumentsView',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();
  const showSpinner = ref(true);
  const documents = computed(() => store.state.user.data.detailsId.documents);
  const isOpenedModal = ref(false);
  const activeRowIndex = ref(-1);
  const { detailsId } = getUser();
  const showDocumentsActions = ref(false);
  const fileForDelete = ref({ file: "", index: 0 });
  const isOpenRemoveDocumentsModal = ref(false);

  function onDocumentsDots() {
    showDocumentsActions.value = !showDocumentsActions.value;
  }
  function onUploadButton() {
    isOpenedModal.value = true;
  }
  function onDots(index: number) {
    activeRowIndex.value = activeRowIndex.value === index ? -1 : index;
  }
  function clickOutside() {
    activeRowIndex.value = -1;
  }
  function clickOutsideDocuments() {
    showDocumentsActions.value = false;
  }
  function showDeleteFileModal(file: string, index: number) {
    fileForDelete.value = { file, index };
    isOpenRemoveDocumentsModal.value = true;
  }
  function onDelete() {
    isOpenRemoveDocumentsModal.value = false;
    showSpinner.value = true;
    store
      .dispatch("customer/removeCustomerDocument", {
        id: detailsId._id,
        fileName: fileForDelete.value.file,
      })
      .then(() => {
        store.commit("user/deleteCustomerDocument", fileForDelete.value.index);
        showSpinner.value = false;
      });
  }
  function onDownload() {
    window.open(documents.value[activeRowIndex.value].link);
  }
  function updateUserInfo() {
    showSpinner.value = true;
    store
      .dispatch("user/updateUser", { id: getUser()._id })
      .then(() => (showSpinner.value = false));
  }
  function afterSuccessUpload(details: CustomerDetails) {
    store.commit("user/setCustomerDetails", details);
  }
  function getDropdownPosition(index: number) {
    return {
      right: "0",
      top: index < documents.value.length - 2 ? "30px" : "initial",
      bottom: index < documents.value.length - 2 ? "initial" : "100%",
    };
  }

  onMounted(() => {
    updateUserInfo();
  });

const __returned__ = { store, showSpinner, documents, isOpenedModal, activeRowIndex, detailsId, showDocumentsActions, fileForDelete, isOpenRemoveDocumentsModal, onDocumentsDots, onUploadButton, onDots, clickOutside, clickOutsideDocuments, showDeleteFileModal, onDelete, onDownload, updateUserInfo, afterSuccessUpload, getDropdownPosition, computed, onMounted, ref, get useStore() { return useStore }, CustomerDetailsCardEmpty, CustomerUploaderModal, ActionsComponent, RemoveDocumentsModal, get formatDateMonthDayYear() { return formatDateMonthDayYear }, get router() { return router }, get getUser() { return getUser }, DocumentItemWithSlot, DocumentItem, get CustomerDetails() { return CustomerDetails } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})